import { nortadaLogger } from '../../../../../../common/logger';
import SuccessOperation from './successOperation';
import FailureOperation from './failureOperation';
import UnknownOperation from './unknownOperation';
import { Operation } from './interfaces';

interface Props {
  operation: Operation;
}

const OperationSearchResults = ({ operation }: Props) => {
  switch (operation.status) {
    case 'success': {
      return <SuccessOperation operation={operation} />;
    }
    case 'failure': {
      return <FailureOperation operation={operation} />;
    }
    case 'unknown': {
      return <UnknownOperation operation={operation} />;
    }
    default: {
      nortadaLogger.critical(`Error in Customer Authentication > Billing > Operation search.
      ${operation.status} is not supported operation status.
      Should be success, failure or unknown.`);

      return null;
    }
  }
};

export default OperationSearchResults;
